import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const parallaxOnScroll = () => {

	const els = document.querySelectorAll('[data-speed]')
	
	els.forEach(el => {
		if (el.dataset.top) {
			gsap.to(el, {
				y: (i, el) => (1 - parseFloat(el.getAttribute('data-speed'))) * window.innerHeight,
				ease: 'none',
				scrollTrigger: {
					trigger: el,
					start: 0,
					end: 'bottom top',
					invalidateOnRefresh: true,
					scrub: 1,
				}
			})
		} else {
			gsap.to(el, {
				y: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * window.innerHeight,
				ease: 'none',
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					end: 'bottom top',
					invalidateOnRefresh: true,
					scrub: 1,
				}
			})
		}
	})
}

export const parallaxOnMouse = () => {

	const moveElements = (event) => {
		document.querySelectorAll("[data-parallax]").forEach((shift) => {
			if (isInViewport(shift)) {
				const position = shift.getAttribute("data-parallax")
				const x = (window.innerWidth - event.pageX * position) / 90
				const y = (window.innerHeight - event.pageY * position) / 90
				gsap.to(shift, { duration: 1.5, x: x, y: y})
			}
		})
	}
	
	document.addEventListener('mousemove', moveElements)

	const isInViewport = (el) => {
		const rect = el.getBoundingClientRect()
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		)
	}
}

export default () => {}